import React from 'react'

import { connect } from 'react-redux'
import { Add_Level } from '../../../../../../Store/Actions/Setting.Action'

import { TextField, Button, CircularProgress } from '@mui/material'


class SettingLevelAdd extends React.Component {
    state = {
        Nama: '',
        isNamaError: false,
        Deskripsi: ''
    }
    onChangeField = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    changeToError = (e, value) => {
        this.setState({ isNamaError: value })
    }
    formOnSubmit = (e) => {
        e.preventDefault()
        this.props.Add_Level(this.state.Nama, this.state.Deskripsi)
    }
    render() {
        const {
            Nama,
            isNamaError,
            Deskripsi,
        } = this.state

        const isLevelActionAddLoading = this.props.isLevelActionAddLoading
        const isLevelExist = this.props.isLevelExist

        return (

            <form
                onSubmit={this.formOnSubmit}
            >
                <div
                    style={{ margin: '0 5% 0 5%' }}
                >
                    <TextField
                        label='Nama'
                        type='text'
                        name='Nama'
                        value={Nama}
                        required
                        onInvalid={(e) => this.changeToError(e, true)}
                        onChange={this.onChangeField}
                        style={{ width: '100%', margin: '1% 0 1% 0' }}
                        error={isLevelExist || isNamaError ? true : false}
                        helperText={isLevelExist ? 'Level Sudah Ada' : isNamaError ? 'Nama Harus diisi' : ''}
                    />
                    <TextField
                        label='Deskripsi'
                        type='text'
                        name='Deskripsi'
                        value={Deskripsi}
                        onChange={this.onChangeField}
                        style={{ width: '100%', margin: '1% 0 1% 0' }}
                    />
                </div>
                <center>
                    <Button
                        variant='contained'
                        size='large'
                        style={{ border: '0px solid red', width: "85%", margin: '3% 0 2% 0' }}
                        type='submit'
                        disabled={isLevelActionAddLoading ? true : false}
                    >
                        {isLevelActionAddLoading ? <CircularProgress /> : 'Add Level'}
                    </Button>
                </center>
            </form>
        )
    }
}

const mapStateToProps = state => ({
    isLevelActionAddLoading: state.Setting.isLevelActionAddLoading,
    isLevelExist: state.Setting.isLevelExist,
})

export default connect(mapStateToProps, { Add_Level })(SettingLevelAdd)